import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./tokens.css";

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("elemento #raiz não encontrado");

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Só existe pra habilitar "Instalar app" (design §5.3) — o service worker em
// si não cacheia dado nenhum de tenant. Registrado depois do load pra não
// disputar banda com o primeiro render.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Instalação de PWA é conveniência, não requisito — se o registro
      // falhar (ex.: contexto não seguro), o app segue funcionando na aba.
    });
  });
}
